import Stack from '@mui/material/Stack';
import React from 'react';
import DocumentTitle from '../../utilComponents/DocumentTitle';
import PricesExport from './PricesExport';
import ProductsExport from './ProductsExport';
import ProductMenuExport from './ProductMenuExport';
import PromotionsExport from './PromotionsExport';
import CouponsExport from './CouponsExport';

export default function ExportView() {
  return (
    <>
      <DocumentTitle translationID="export.headline" />

      <Stack gap={4}>
        <ProductsExport />
        <PricesExport />
        <ProductMenuExport />
        <PromotionsExport />
        <CouponsExport />
      </Stack>
    </>
  );
}
